<!-- src/components/ChatSuggestions.vue -->
<template>
  <div v-if="noQuestionsAsked" class="outer">
    <div class="guidance">
      <p>{{ welcomeMessage }}</p>
      <p v-if="view !== 'uat'">Some common questions are shown below.</p>
    </div>
    <div class="initial-chat-outer">
      <ChatInputText />
      <div class="grid" v-if="view !== 'uat'">
        <div
          class="suggestions-container"
          v-for="(suggestion, index) in initialSuggestions"
          :key="index"
        >
          <button
            class="button"
            @click="askQuestion(suggestion)"
            :value="suggestion"
          >
            <span>{{ suggestion }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, ref } from 'vue';
import { useQuestionStore } from '../store/questionStore';
import { useAppStore } from '../store/appStore';
import ChatInputText from './ChatInputText.vue';

const initialSuggestions = [
  'I want to pay my council tax',
  'What is my rent balance?',
  'How do I register a birth?',
  'When is my bin collection'
];

export default {
  components: {
    ChatInputText
  },
  setup() {
    const currentQuestion = ref<string>('');
    const questionStore = useQuestionStore();
    const { view, welcomeMessage, prompt } = useAppStore();
    // Use computed to ensure reactivity is preserved
    const answerLoading = computed(() => questionStore.answerLoading);
    const noQuestionsAsked = computed(
      () => questionStore.conversations.length === 0
    );

    const askQuestion = (question: string) => {
      questionStore.fetchAnswer(question, prompt, view);
      currentQuestion.value = '';
    };

    return {
      initialSuggestions,
      askQuestion,
      answerLoading,
      noQuestionsAsked,
      view,
      welcomeMessage
    };
  }
};
</script>

<style scoped>
.outer {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-top: 0px;
  margin: 6px;
  flex: 1;
}

.initial-chat-outer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 440px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  width: 100%;
  max-width: 100%;
  justify-items: stretch;
}

.button {
  border: 1px solid rgb(24, 22, 22);
  color: white;
  background-color: #320a4b;
  padding: 16px;
  width: 100%;
  height: 100%;
  white-space: normal;
  font-size: 14px;
  cursor: pointer;
}

.button:hover {
  background-color: white;
  color: black;
  transition-duration: 400ms;
}

.guidance {
  text-align: center;
  text-wrap: balance;
  margin-bottom: 20px;
}

/* Add media query for 500px */
@media (max-width: 500px) {
  .initial-chat-outer {
    width: 100%;
  }

  .grid {
    grid-template-columns: 1fr;
    min-width: 100%;
  }
}
</style>
